export default (obj,type)=>{
    return {
        type:type,
        payload:obj
    }
}